
let multiformHelper = {

    checkResponse: function(response) {

        let validationObj = {
            formErrorMsg: false,
            formSuccessMsg: false,
            formError: {}
        };

        if(response.validateOk!==undefined && response.validateOk==false)
        {
            for ( var key in response.formError ) 
            {
                if(response.formError[key]!==undefined)
                {
                    validationObj.formError[key] = response.formError[key];
                }
            }

            validationObj.formErrorMsg = true;
        }
        else if(response.status == true)
        {
            validationObj.formSuccessMsg = true;
            
            // Na success sakrijem formular, prikazem poruku uspjeha
            // moram jQuery jer je element izvan Vue App-a

            document.querySelectorAll(".js-form-block").forEach((el) => {
                el.classList.add('d-none');
            });

            document.querySelectorAll(".js-success-block").forEach((el) => {
                el.classList.remove('d-none');
            });

            window.scrollTo({ top: 0, behavior: 'smooth' });
        }


        return validationObj;
    },

    submitWithRecaptcha3: function(url, data, cb) {
    
        // create HTTP multipart form data
        var form_data = new FormData();
        for ( var key in data ) {
            form_data.append(key, data[key]);
        }




        //TODO remove!!!
        return this.submitWithoutRecaptcha(url, form_data, cb);




        grecaptcha.ready(() => {
            grecaptcha.execute(googleRecapctha3Key, {action: 'submit'}).then((token) => {

                form_data.append('grecaptcha', token);

                // post form
                axios
                    .post(url, form_data, {headers: { "Content-Type": "multipart/form-data" }})
                    .then(response =>{
                        cb(multiformHelper.checkResponse(response.data));
                    });
            });
        });
    },

    submitWithoutRecaptcha: function (url, form_data, cb) {
        // post form
        axios
            .post(url, form_data, {headers: { "Content-Type": "multipart/form-data" }})
            .then(response =>{
                cb(multiformHelper.checkResponse(response.data));
            });
    }

}

module.exports = multiformHelper;